<template src="./task.html"></template>
<script>
  import { mapState } from "vuex";
  import Axios from "axios";
  import LicenceCategories from "@/assets/json_data/licence_categories.json";
  var moment = require("moment");
  export default {
    components: {},
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
      datetime: function (data) {
        if (data == "" || data == null) {
          return "--";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        var reqTString = "";
        for (let i = 11; i < 16; i++) {
          reqTString += data[i];
        }
        var arr = reqTString.split(":");
        if (arr[0] >= 12) {
          reqTString = arr[0] - 12 + ":" + arr[1] + " PM";
        } else {
          reqTString = arr[0] + ":" + arr[1] + " AM";
        }
        return reqdString + " " + reqTString;
      },
    },
    props: {
      RequestFor: String,
      RequestStatus: String,
      height: String / Number,
      DriverId: String / Number,
      VehicleId: String / Number,
    },
    data() {
      return {
        newHeight: "350px",
        UpcomingTask: [],
        VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
        ImageEndpoint: Endpoints.Helper.Image + "/",
        Task: {},
        ShowTaskActionModel: "",
        TaskActionModelHeading: "",
        SubmitTask: {},
        TaskFilter: "All",
        PopupLoader: false,
        trailersModule: false,
        file: "",
        Categories: LicenceCategories,
        ViewDocument: {},
        ShowViewDetailModel: false,
        MOTType: "MOT",
      };
    },
    computed: {},
    mounted() {
      if (typeof this.height != "undefined") {
        this.newHeight = this.height + "px";
      }
      this.GetCompanySubscription();
      this.GetUpcomingTaskList();
      this.initSubmitTaskObject();
    },
    methods: {
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isTrailer = FleetSubscriptionModules.Trailers;
        if (isTrailer) {
          this.trailersModule = true;
        }
      },
      initSubmitTaskObject() {
        var user = JSON.parse(localStorage.getItem("User"));
        this.SubmitTask = {
          action: 0,
          date_fixed: "",
          notes: "",
          confirm: false,
          licence_category: "",
          licence_number: "",
          licence_expiry_date: "",
          cpc_expiry_date: "",
          adr_expiry_date: "",
          mot_appointment_date: "",
          mot_passed: "",
          pmi_appointment_date: "",
          pmi_passed: "",
          psv_appointment_date: "",
          psv_passed: "",
          service_booked_date: "",
          serviced_date: "",
          next_service_date: "",
          serviced_due_month: "1 Year",
          serviced_due_miles: "10000",
          serviced_due_soonest: "1",
          sorn: false,
          tax_auto_renew: false,
          tax_renew_date: "",
          action_username: user.forename + " " + user.surname,
          insurance_auto_renew: false,
          insurance_renew_date: "",
          service_document: "",
          service_document_name: "",
          penalty_point: "",
        };
      },
      GetUpcomingTaskList() {
        Axios.post(Endpoints.Task.GET_LIST, {
          token: localStorage.getItem("token"),
          RequestFor: this.RequestFor,
          VehicleId: this.VehicleId,
          DriverId: this.DriverId,
        }).then((Response) => {
          if (Response.data.success) {
            this.UpcomingTask = Response.data.upcoming_task;
          }
        });
      },
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
      },
      UploadFile() {
        this.PopupLoader = true;
        let formData = new FormData();
        formData.append("token", localStorage.getItem("token"));
        formData.append("storage_type", "CFV");
        formData.append("file", this.file);
        Axios.post(Endpoints.File.Upload, formData).then((Response) => {
          this.PopupLoader = false;
          if (Response.data.success == true) {
            this.SubmitTask.service_document = Response.data.file;
            this.SubmitTask.service_document_name = this.file.name;
            this.$swal
              .fire("File Uploaded Successfully", "", "success")
              .then(() => {});
          } else {
            this.$swal
              .fire("Error in File Uploading", "", "error")
              .then(() => {});
          }
        });
      },
      ShowTaskAction(task) {
        this.ShowTaskActionModel = true;
        console.log("task", task);
        this.Task = task;
        if (task.type == "vehiclecheck" && task.status == "yellow") {
          this.TaskActionModelHeading =
            this.RequestFor == "TrailerList" ||
            this.RequestFor == "TrailerProfile"
              ? "Trailer Check Warning Action"
              : "Vehicle Check Warning Action";
        }
        if (task.type == "vehiclecheck" && task.status == "red") {
          this.TaskActionModelHeading =
            this.RequestFor == "TrailerList" ||
            this.RequestFor == "TrailerProfile"
              ? "Trailer Check Failure Action"
              : "Vehicle Check Failure Action";
        }

        if (task.type == "document") {
          this.TaskActionModelHeading = "Document Expire";
        }

        if (task.type == "driver" && task.type2 == "license") {
          this.TaskActionModelHeading = "Licence Expire";
        }

        if (task.type == "driver" && task.type2 == "cpc") {
          this.TaskActionModelHeading = "CPC Expire";
        }

        if (task.type == "driver" && task.type2 == "adr") {
          this.TaskActionModelHeading = "ADR Expire";
        }

        if (task.type == "vehicle" && task.type2 == "mot_due") {
          this.TaskActionModelHeading = task.task;
        }

        if (task.type == "vehicle" && task.type2 == "psv_date") {
          this.TaskActionModelHeading = "PSV Expire";
        }

        if (task.type == "vehicle" && task.type2 == "next_pmi_due") {
          this.TaskActionModelHeading = "PMI Expire";
        }

        if (task.type == "vehicle" && task.type2 == "mot_appointment") {
          this.TaskActionModelHeading = task.task;
        }

        if (task.type == "vehicle" && task.type3) {
          this.MOTType = task.type3;
        }

        if (task.type == "vehicle" && task.type2 == "pmi_appointment") {
          this.TaskActionModelHeading = "PMI Appointment";
        }

        if (task.type == "vehicle" && task.type2 == "service_due") {
          this.TaskActionModelHeading = "Service Due";
        }

        if (task.type == "vehicle" && task.type2 == "service_appointment") {
          this.TaskActionModelHeading = "Service Appointment";
        }

        if (task.type == "vehicle" && task.type2 == "tax_due") {
          this.TaskActionModelHeading = "Tax Due";
        }
      },
      TaskActionSubmit() {
        console.log("task", this.Task);
        console.log("SubmitTask", this.SubmitTask);
        var error = false;
        var errorStr = "";

        /* check error for vehicle check*/
        if (this.Task.type == "vehiclecheck") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.date_fixed == "") {
            error = true;
            errorStr += "<li>Please Select Date Fixed</li>";
          }
          if (this.SubmitTask.action == 3 && !this.SubmitTask.confirm) {
            error = true;
            errorStr +=
              "<li>Please Confirm Clear warning without addressing</li>";
          }
        }

        /* check error for document*/
        if (this.Task.type == "document") {
          if (!this.SubmitTask.confirm) {
            error = true;
            errorStr +=
              "<li>Please Check Clear document from upcoming and expired tasks list</li>";
          }
        }

        /* check error for driver license*/
        if (this.Task.type == "driver" && this.Task.type2 == "license") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.licence_expiry_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Enter Licence Expiry Date</li>";
          }
        }

        /* check error for driver license check*/
        if (this.Task.type == "driver" && this.Task.type2 == "license_check") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 2 &&
            this.SubmitTask.penalty_point == ""
          ) {
            error = true;
            errorStr += "<li>Please Enter Penalty Point</li>";
          }
        }

        /* check error for driver CPC*/
        if (this.Task.type == "driver" && this.Task.type2 == "cpc") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.cpc_expiry_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Enter CPC Expiry Date</li>";
          }
        }

        /* check error for driver ADR*/
        if (this.Task.type == "driver" && this.Task.type2 == "adr") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.adr_expiry_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Enter ADR Expiry Date</li>";
          }
        }

        /* check error for MOT Due*/
        if (this.Task.type == "vehicle" && this.Task.type2 == "mot_due") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.mot_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of MOT Appointment</li>";
          }

          if (this.SubmitTask.action == 2 && this.SubmitTask.mot_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed MOT</li>";
          }
        }

        /* check error for PMI Due*/
        if (this.Task.type == "vehicle" && this.Task.type2 == "pmi_due") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.pmi_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of PMI Appointment</li>";
          }

          if (this.SubmitTask.action == 2 && this.SubmitTask.pmi_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed PMI</li>";
          }
        }

        /* check error for PSV Date*/
        if (this.Task.type == "vehicle" && this.Task.type2 == "psv_date") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.psv_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of PSV Appointment</li>";
          }

          if (this.SubmitTask.action == 2 && this.SubmitTask.psv_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed PSV</li>";
          }
        }

        /* check error for MOT Appointment*/
        if (
          this.Task.type == "vehicle" &&
          this.Task.type2 == "mot_appointment"
        ) {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.mot_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed MOT</li>";
          }
          if (
            this.SubmitTask.action == 2 &&
            this.SubmitTask.mot_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of MOT Appointment</li>";
          }
        }

        /* check error for PMI Appointment*/
        if (
          this.Task.type == "vehicle" &&
          this.Task.type2 == "pmi_appointment"
        ) {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.pmi_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed PMI</li>";
          }
          if (
            this.SubmitTask.action == 2 &&
            this.SubmitTask.pmi_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of PMI Appointment</li>";
          }
        }

        /* check error for PSV Appointment*/
        if (
          this.Task.type == "vehicle" &&
          this.Task.type2 == "psv_appointment"
        ) {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (this.SubmitTask.action == 1 && this.SubmitTask.psv_passed == "") {
            error = true;
            errorStr += "<li>Please Select Date of passed PSV</li>";
          }
          if (
            this.SubmitTask.action == 2 &&
            this.SubmitTask.psv_appointment_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of PSV Appointment</li>";
          }
        }

        /* check error for Service Due*/
        if (this.Task.type == "vehicle" && this.Task.type2 == "service_due") {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.service_booked_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Date of Service Appointment</li>";
          }
          if (
            this.SubmitTask.action == 2 &&
            this.SubmitTask.serviced_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select When was this Vehicle Serviced</li>";
          }
        }

        /* check error for Service Appointment*/
        if (
          this.Task.type == "vehicle" &&
          this.Task.type2 == "service_appointment"
        ) {
          if (this.SubmitTask.action < 1) {
            error = true;
            errorStr += "<li>Please Select Action</li>";
          }
          if (
            this.SubmitTask.action == 1 &&
            this.SubmitTask.serviced_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select When was this Vehicle Serviced</li>";
          }
        }

        /* check error for Tax Due*/
        if (this.Task.type == "vehicle" && this.Task.type2 == "tax_due") {
          if (
            this.SubmitTask.sorn == false &&
            this.SubmitTask.tax_auto_renew == false &&
            this.SubmitTask.tax_renew_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Any Action</li>";
          }
        }

        /* check error for Tax Due*/
        if (
          this.Task.type == "vehicle" &&
          this.Task.type2 == "insurance_expire"
        ) {
          if (
            this.SubmitTask.insurance_auto_renew == false &&
            this.SubmitTask.insurance_renew_date == ""
          ) {
            error = true;
            errorStr += "<li>Please Select Any Action</li>";
          }
        }

        if (error == true) {
          this.$swal("Following Error Found!", errorStr, "error").then(
            () => {}
          );
        } else {
          this.$swal({
            title: "Updating Task...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.Task.TaskSubmit, {
            token: localStorage.getItem("token"),
            Task: this.Task,
            SubmitTask: this.SubmitTask,
          }).then((Response) => {
            if (Response.data.success == true) {
              this.ShowTaskActionModel = false;
              this.GetUpcomingTaskList();
              this.initSubmitTaskObject();
              this.$swal("Task Updated Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal(Response.data.message, "", "error").then(() => {});
            }
          });
        }
      },
      ViewDetailDocument(document) {
        console.log(document);
        this.ViewDocument = document;
        this.ShowViewDetailModel = true;
      },
    },
  };
</script>

<style type="text/css">
  .UpcomingTaskList td {
    vertical-align: top !important;
    padding-top: 5px !important;
    font-weight: normal !important;
  }
  .UpcomingTaskList td.statusbtn .btn,
  .UpcomingTaskList td.actionbtn .btn {
    width: 100%;
  }
  .UpcomingTaskList td.event,
  .UpcomingTaskList td.vrm {
    text-transform: capitalize;
  }
  .UpcomingTaskList .completebtn.btn-primary:hover {
    background-color: #51bb25 !important;
    border-color: #51bb25 !important;
  }
  #ShowTaskActionModel span.plate {
    display: inline-flex;
    vertical-align: top;
  }
  #ShowTaskActionModel .form-control-check {
    margin-left: 10px;
    margin-right: 3px;
    vertical-align: text-top;
  }
</style>
